import angular from 'angular';

import deploymentFrequencyComponent from './deployment-frequency.component';

export default angular.module('dbm.dashboard.components.widgets.deployment-frequency', [])
.component('dbmDeploymentFrequencyWidget', deploymentFrequencyComponent)
.name;



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/components/widgets/deployment-frequency/index.js